import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const styles = createStyleSheet({
  wrapper: {
    height: '100%',
    /**
     * We want the date picker to be visible when spreading over the right part of the panel.
     * However, setting overflow-y: auto prevents us from setting overflow-x: visible so we need
     * to have a big enough width.
     *
     * (see https://teamtreehouse.com/community/overflow-y-not-visible-when-overflow-x-is-set-to-scroll)
     */
    width: 305,
    overflowY: 'auto',
    flexShrink: 0,
    paddingTop: 32,
    backgroundColor: COLORS.WHITE.DEFAULT,
    position: 'relative',
    borderRight: `1px solid ${COLORS.GREY_MEDIUM.DEFAULT}`,
  },
  locked: {
    position: 'absolute',
    width: 300,
    top: 0,
    left: 0,
    height: 'calc(100% + 32px)',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 2,
    textAlign: 'center',
    paddingTop: 244,
    paddingRight: 98,
    paddingLeft: 98,
  },
  unlocked: {
    display: 'none',
  },
  divider: {
    height: 1,
    marginBottom: 23,
  },
});

export const sharedPanelFormStyles = createStyleSheet({
  box: {
    margin: '0 16px 24px 16px',
  },
  title: {
    marginBottom: 8,
    ...TYPOGRAPHY.HERO_S_SEMIBOLD,
  },
  subtitle: {
    ...TYPOGRAPHY.H2,
    marginBottom: 8,
  },
  element: {
    marginBottom: 20,
  },
  contentElement: {
    marginBottom: 8,
  },
  input: {
    width: 50,
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 4,
    borderColor: COLORS.GREY_DARK.DEFAULT,
    marginRight: 8,
  },
  internalInputStyle: {
    textAlign: 'center',
  },
  daySelector: {
    marginLeft: -4,
  },
  disabledDayContainer: {
    marginBottom: 10,
    display: 'flex',
  },
  disabledDayDatePicker: {
    flexGrow: 1,
    marginRight: 16,
  },
});

export default styles;
